<template>
  <div>
    <!-- toolbar -->
    <div
      id="fade-toolbar"
      class="search-top-city-container"
    >

      <div class="toolbar-content-container pos-rel">
        <i
          @click="$router.go(-1)"
          class="material-icons"
          style="left:0.625em; position: absolute">
          keyboard_arrow_left
        </i>

        <!-- loc and search -->
        <div class="loc-and-search" >
          <i class="material-icons"
             :style="getToShowFilter.filterVal !== 'Filter'? 'color: rgb(74, 144, 226)': ''"
             @click="saveMode()
             ;$router.push({path:'/filter', query: $route.query})">
            tune
          </i>

          <div

            @click="saveMode();$router.push({path:'/filter', query: $route.query})"
            style="display: flex;
            align-items: center;
            margin-left: 0.5em;
            margin-right: 1em;
            text-transform: capitalize">
            {{getToShowFilter.filterVal}}
          </div>




          <i class="material-icons" @click="$router.push({path:'/search_locations', query: $route.query})">search</i>

          <div
            @click="$router.push({path:'/search_locations', query: $route.query})"
            style="display: flex; align-items: center;margin-left: 0.5em">
            {{selectedCity | getName}}
            <!--i class="material-icons" style="margin-left: 0.5em">
              keyboard_arrow_down
            </i-->
          </div>
          <!--select
            v-model="selectedCity"
            :style="`width: ${getWidthOfSelOnBasisOfSelCity}em`"
            style="z-index: 10; text-align: left;"
          >
            <option
              value="Berlin"
            >
              Berlin
            </option>
            <option value="Elsewhere">
              Worldwide
            </option>
          </select-->
        </div>
        <!-- /loc and search -->

        <!-- dropdown - mode -->
        <div class="select-screen-mode-container">
          <div class="select-screen-mode" @click="$store.state.common.swichModesBG = !$store.state.common.swichModesBG">
            <div>Modes</div>
            <i class="material-icons"
               :style="$store.state.common.swichModesBG? 'color: #febd35': ''"
            >{{$store.state.common.swichModesBG ? 'keyboard_arrow_up': 'expand_more'}}</i>
          </div>
        </div>
        <!-- /dropdown - mode -->
      </div>
    </div>
    <!-- /toolbar -->


    <div class="container-switch-modes" >
      <div class="switch-container">
        <div class="mode-container"
             @click="clickedMode('map'); $store.state.common.swichModesBG = false"
             :style="$route.path === '/map'? 'color: rgb(245, 166, 35)': ''">
          <i class="material-icons">map</i>
          <div class="screen-type">Map View</div>
          <div>
            <img alt="map mode" src="https://res.cloudinary.com/xviewzzzx/image/upload/h_300,f_auto,fl_lossy,q_auto,dpr_auto,e_improve/v1552235755/modes/map">
          </div>
        </div>
        <div class="mode-container"
             :style="!$store.state.common.isModeSwipe && $route.path === '/'? 'color: rgb(245, 166, 35)': ''"
             @click="clickedMode('list');
             $store.state.common.swichModesBG = false">
          <i class="material-icons">view_day</i>
          <div class="screen-type">List View</div>
          <div>
            <img alt="list mode" src="https://res.cloudinary.com/xviewzzzx/image/upload/h_300,f_auto,fl_lossy,q_auto,dpr_auto,e_improve,dpr_auto/v1552235755/modes/list">
          </div>
        </div>

        <div class="mode-container"
             v-if="screenW < 600"
             :style="$store.state.common.isModeSwipe && $route.path === '/'? 'color: rgb(245, 166, 35)': ''"
             @click="clickedMode('full');
             $store.state.common.swichModesBG = false">
          <i class="material-icons">settings_overscan</i>
          <div class="screen-type">Full screen</div>
          <div>
            <img alt="full mode" src="https://res.cloudinary.com/xviewzzzx/image/upload/h_300,f_auto,fl_lossy,q_auto,dpr_auto,e_improve/v1552235755/modes/full">
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  let vm
  export default {
    data: () => {
      return {
        screenW: screen.width,
        selectedCity: 'Berlin'
      }
    },
    methods: {
      clickedMode(mode) {
        this.$emit('getClick', mode)
      },
      saveMode() {
        localStorage.setItem('MODE', this.$store.state.common.isModeSwipe)
      }
    },
    computed: {
      getToShowFilter() {
        let obj = {
          filterVal: 'Filter'
        }
        let _routes = JSON.parse(JSON.stringify(vm.$route.query))
        if(Object.keys(_routes).length > 1) {
          for(let i in _routes) {
            if(i !== 'loc' && i !== 'sortBy' && i !== 'createdAt') {
              obj.filterVal = _routes[i]

            }
          }
        }
        return obj
      },
      getWidthOfSelOnBasisOfSelCity () {
        if (this.selectedCity === `Berlin`) {
          return '4.7'
        }
        else if (this.selectedCity === `Elsewhere`) {
          return '6.7'
        }
      },
    },
    filters: {
      getName: function () {
        let str = vm === undefined? '': vm.selectedCity
        if(str.length > 20) {
          let s = str.substring(0, 20)
          return `${s}...`
        }
        else {
          return str
        }
      }
    },
    watch: {
      'selectedCity' : () => {
        // console.log(`selectedCity: `, vm.selectedCity, vm)
        if(vm.$route.path != '/login') {
          let obj = Object.assign({}, vm.$route.query)
          obj.loc=vm.selectedCity
          vm.$router.push({
            path: vm.$route.path,
            query: Object.assign({}, obj)
          })
        }
        else {
          let obj = Object.assign({}, vm.$route.query)
          obj['loc'] = 'Berlin'
          vm.$router.replace({
            path: vm.$route.path,
            query: Object.assign({}, obj)
          })
        }
      },
    },
    created() {
      vm = this
    },
    mounted() {
      window.addEventListener("resize", () => {
        vm.screenW = screen.width
      })
      // console.log(`WHy arent == --? :/`, this.$route)
      if (this.$route.query.loc !== this.selectedCity) {
        this.selectedCity = this.$route.query.loc
        if(this.selectedCity === undefined) {
          this.selectedCity = "Berlin"
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .search-top-city-container{
    z-index: 99999;
    top: 0;
    left: 0;
    width: 100vw;
    position: absolute;
    background: linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.61) 90%);
    // background: rgba(0,0,0,0.50);
    color: white;
    height: 7.143em;
    text-align: center;

    .toolbar-content-container{
      width: 100%;
      margin-top: 1.571em;
      color: rgba(225, 225, 225, 1);
      display: flex;
      align-items: center;
      justify-content: center;


      .loc-and-search {
        display: flex;
        align-items: center;
        i {
          font-size: 1.286em;
        }
        select {
          outline: none;
          text-align: center;
          margin-left: 1.500em;
          font-size:1em !important;
        }
      }


      .select-screen-mode-container {
        width: fit-content;
        right: 1.786em;
        position: absolute;
        height: 100%;
        .select-screen-mode {
          display: flex;
          height: 100%;
          align-items: center;
        }
      }
    }


    .search-city-relative {
      position: relative;
      width: 100%;

      //
      display: flex;
      align-items: center;
      justify-content: space-between;

      i{
        opacity: 0.6;
        // padding: 0 10px ;
        color: white;
        font-size: 1.286em;
      }
      .i-1{
        //position: absolute;
        left: 20px
      }
      .i-2 {
        //position: absolute;
        left: 65px;
      }
      .i-3 {
        //bottom: 3px;
        //position: absolute;
        //right: 63px;
        right: 3em;
      }
      .i-4 {
        //bottom: 3px;
        //position: absolute;
        right: 22px;
      }
    }

  }

  select {
    font-size: 1.143em!important;
    // font-family: 'Roboto Slab', serif;
    font-weight: 700!important;
    //
    //background-image: url('https://png.icons8.com/ios/11/ffffff/expand-arrow.png'); /* The image used */
    //background-color: transparent; /* Used if the image is unavailable */
    //height: 500px; /* You must set a specified height */
    //background-position: right 0px top 0.392em; /* Center the image */
    //background-repeat: no-repeat; /* Do not repeat the image */
    //background-size: cover; /* Resize the background image to cover the entire container */
  }

  .container-switch-modes {
    top:-50vh;
    left: 0;
    position: absolute;
    z-index: 4000;
    height: 18.357em;
    display: flex;
    justify-content: center;
  }

  .switch-container {
    border-radius: 4px;
    background: black;
    border: 1.5px solid #4a4a4a;
    width: calc(100vw - 5%);
    height: 100%;
    grid-template-columns: auto auto auto;
    display: grid;

    .mode-container {
      color: white;
      padding: 1em;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;

      img {
        height: 11.5em;
        width: 100%;
        object-fit: contain;
      }

      .screen-type {
        padding-bottom: 1em;
        line-height: 1;
        font-size: 0.768em;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// toolbar.vue?14ec1b2b